const SERVICES = [
  {
    title: "Agent Persona Workshops",
    desc: "Deep, two-day discovery to define voice, values, and visual identity. Walk away with a brand you can build on.",
  },
  {
    title: "Broker Brand Development",
    desc: "Full brand systems for offices and brokerages — identity, design tokens, templates, and rollout playbooks.",
  },
  {
    title: "Social Media Strategy & Design",
    desc: "Deliberate content calendars, Canva systems, and rituals that keep showing up — even on listing-heavy weeks.",
  },
  {
    title: "Brand Anthems & Commercial Films",
    desc: "Concept, produce, and deliver films that capture attention and hold it. Cinematic quality with strategic intent. Starting at $6,000.",
  },
];

export default function Agency() {
  return (
    <section
      id="agency"
      data-testid="agency-section"
      className="py-20 md:py-32 border-t border-black/10 bg-[#081812] text-[#ffffff]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Section header */}
        <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-3">
            <span
              className="overline"
              style={{ color: "rgba(255,255,255,0.6)" }}
            >
              06 — Brand &amp; Agency
            </span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.01em]">
              Market your{" "}
              <span className="italic-display text-[#c9a878]">brand</span> —
              <br className="hidden md:block" /> not just the listing.
            </h2>
            <p className="mt-6 text-[15px] md:text-[17px] leading-[1.7] text-[#d4d4d2] max-w-2xl">
              Most agents and offices are built to close. Few are built to be
              remarkable. That&apos;s where we come in — as a true brand,
              creative, and social media partner.
            </p>
          </div>
        </div>

        {/* Services — 2×2 breakdown */}
        <div className="border-t border-white/15">
          <span
            className="overline block pt-6 md:pt-8 pb-8"
            style={{ color: "rgba(255,255,255,0.55)" }}
          >
            What we do
          </span>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 md:gap-x-16">
            {SERVICES.map((s, i) => (
              <article
                key={s.title}
                data-testid={`agency-service-${i + 1}`}
                className="border-t border-white/15 py-8 md:py-10 grid grid-cols-12 gap-4"
              >
                <div
                  className="col-span-2 overline"
                  style={{ color: "rgba(255,255,255,0.55)" }}
                >
                  0{i + 1}
                </div>
                <div className="col-span-10">
                  <h3 className="font-serif-display text-2xl md:text-3xl">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[14px] leading-[1.7] text-[#cfcfcf]">
                    {s.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-14 md:mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-white/15 pt-10">
          <p className="font-serif-display text-2xl md:text-3xl max-w-xl">
            Ready to build a brand{" "}
            <span className="italic-display text-[#c9a878]">that lasts?</span>
          </p>
          <a
            href="#contact"
            data-testid="agency-inquire-cta"
            className="inline-flex items-center gap-4 border border-white/40 text-white px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-medium hover:bg-white hover:text-black transition-colors duration-300"
          >
            Inquire about agency services <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
